import client from 'providers/fetchClient'

export const createContact = data => client.post('/v3/contacts', data)
